import classNames from 'classnames';
import IconFont from '@meitu/xdesign-icon-font';
import styles from './icon-text-item.module.less';

const IconTextItem: React.FC<{
    disabled?: boolean;
    icon?: string;
    iconClassName?: string;
    text?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    showArrow?: boolean;
    showText?: boolean;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    noHover?: boolean;
    active?: boolean;
    marginRight?: number;
    fontSize?: number;
    weight?: number;
    isSelected?: boolean;
    children?: React.ReactNode;
    color?: string;
    paddingLeftRight?: number;
    style?: React.CSSProperties;
    afterIcon?: React.ReactNode;
}> = ({
    noHover = false,
    disabled = false,
    icon,
    iconClassName,
    text = '',
    onClick,
    showArrow = false,
    showText = true,
    onMouseEnter,
    onMouseLeave,
    active = false,
    marginRight = 0,
    children,
    fontSize = 16,
    weight = 400,
    isSelected = false,
    paddingLeftRight = 8,
    color = 'var(--content-system-primary)',
    style,
    afterIcon,
}) => {
    return (
        <div
            className={classNames(styles.container, {
                [styles.disabled]: disabled,
                [styles.noHover]: noHover,
                [styles.active]: active,
                [styles.selected]: isSelected,
                'c-icon-text-item': true,
            })}
            style={{
                marginRight: `${marginRight}px`,
                paddingLeft: `${paddingLeftRight}px`,
                paddingRight: `${paddingLeftRight}px`,
                ...style,
            }}
            onClick={(e) => onClick?.(e)}
            onMouseEnter={() => onMouseEnter?.()}
            onMouseLeave={() => onMouseLeave?.()}
        >
            {children ? (
                children
            ) : (
                <>
                    {icon !== undefined && (
                        <IconFont name={icon} fontSize={fontSize} color={color} className={iconClassName} />
                    )}
                    {showText && text !== '' && (
                        <div className={styles.text}>
                            <span style={{ fontWeight: weight }}>{text}</span>
                            {showArrow && (
                                <IconFont name="ChevronDownBlack" fontSize={8} color="var(--content-system-primary)" />
                            )}
                            {isSelected && <IconFont name="Check" fontSize={12} color="var(--content-list-selected)" />}
                        </div>
                    )}

                    {afterIcon}

                    {showArrow && (!text || !showText) && (
                        <IconFont name="ChevronDownBlack" fontSize={8} color="var(--content-system-primary)" />
                    )}
                </>
            )}
        </div>
    );
};

export default IconTextItem;
